import React from "react";
import { Button, Col, Form, FormControl, InputGroup, Modal, ModalFooter, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faBroom, faFilter } from "@fortawesome/free-solid-svg-icons";

export default function FiltroItensEnviados({filtros, handleAplicarFiltro, closeModal}) {
  const methods = useForm(
    {defaultValues: {
      ...filtros, 
      data_envio_inicio: filtros.data_envio_inicio ? moment(filtros.data_envio_inicio).format("YYYY-MM-DD") : null, 
      data_envio_fim: filtros.data_envio_fim ? moment(filtros.data_envio_fim).format("YYYY-MM-DD") : null}}
  );

  const handleOnSubmit = (data) => {
    handleAplicarFiltro(data);
  }

  return (
    <Form onSubmit={methods.handleSubmit(handleOnSubmit)} className="form-itens-enviados">
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>
              Assunto:
            </Form.Label>
            <InputGroup>
              <FormControl 
                type="text" 
                placeholder="Assunto"
                {...methods.register("assunto")}
              />
            </InputGroup>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Enviado em:
            </Form.Label>
            <InputGroup className="mb-2">
              <InputGroup.Prepend>
                <FormControl 
                  type="date"
                  {...methods.register("data_envio_inicio")}
                />
              </InputGroup.Prepend>
              <InputGroup.Append>
              <FormControl 
                type="date"
                {...methods.register("data_envio_fim")}
              />
              </InputGroup.Append>
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>
              Remetente:
            </Form.Label>
            <InputGroup>
              <FormControl 
                type="text" 
                placeholder="Remetente"
                {...methods.register("remetente")}
              />
            </InputGroup>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Destinatário:
            </Form.Label>
            <InputGroup>
              <FormControl 
                type="text" 
                placeholder="Destinatário"
                {...methods.register("destinatario")}
              />
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>
              Conteúdo:
            </Form.Label>
            <InputGroup>
              <FormControl 
                type="text" 
                placeholder="Conteúdo"
                {...methods.register("conteudo")}
              />
            </InputGroup>
          </Form.Group>
        </Col>
        <FormControl 
          type="checkbox" 
          {...methods.register("slug_meio_comunicacao")}
          value="email"
          hidden
        />
      </Row>
      <ModalFooter className="mb-0 pb-0">
        <Button 
          type="button" 
          variant="secondary" 
          data-dismiss="modal"
          onClick={()=>{closeModal()}}
        >
          <FontAwesomeIcon icon={faBan} className="mr-2"/>
          Fechar
        </Button>
        <Button 
          type="button" 
          variant="info" 
          data-dismiss="modal" 
          onClick={()=>{
            methods.reset({
              'data_envio_inicio': moment().subtract(7, 'days').format("YYYY-MM-DD"),
              'data_envio_fim': moment().format("YYYY-MM-DD"),
            })
          }}
        >
          <FontAwesomeIcon icon={faBroom} className="mr-2"/>
          Limpar
        </Button>
        <Button type="submit" variant="success">
          <FontAwesomeIcon icon={faFilter} className="mr-2"/>
          Aplicar Filtro
        </Button>
      </ModalFooter>
    </Form>
  );
}
